import React, { useState } from 'react';
import { getToken } from '../../utils/getToken';

const baseURL = process.env.REACT_APP_BASE_URL || 'https://api.quickcare.ng/admin';

const AdminInvite = () => {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('Admin');
    const [responseMessage, setResponseMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleInvite = async () => {
        if (!email) {
            setErrorMessage('Please enter an email address');
            setResponseMessage('');
            return;
        }

        setIsLoading(true);
        setResponseMessage('');
        setErrorMessage('');

        const token = getToken();
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);

        const raw = JSON.stringify({ email, role });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        try {
            const response = await fetch(`${baseURL}/admins/invite-admin`, requestOptions);
            const result = await response.json();

            if (response.ok) {
                setResponseMessage('✅ Admin invited successfully!');
                setErrorMessage('');
                setEmail('');
            } else {
                setErrorMessage(result.message || 'Failed to invite user');
                setResponseMessage('');
            }
        } catch (error) {
            console.error("Fetch error:", error);
            setErrorMessage('Network error. Please try again.');
            setResponseMessage('');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 hover:shadow-md transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-8 bg-gradient-to-b from-[#069125] to-[#057a1f] rounded-full"></div>
                <div>
                    <h2 className="text-lg font-bold text-gray-800">Invite Admin</h2>
                    <p className="text-xs text-gray-400">Send invitation to new administrators</p>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1">
                    <input
                        type="email"
                        placeholder="Enter admin email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#069125]/20 focus:border-[#069125] outline-none transition-all duration-200 text-gray-800 placeholder-gray-400"
                    />
                </div>
                <div className="flex gap-3">
                    <select
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#069125]/20 focus:border-[#069125] outline-none transition-all duration-200 text-gray-800 cursor-pointer"
                    >
                        <option value="Admin">Admin</option>
                        <option value="Super Admin">Super Admin</option>
                    </select>
                    <button
                        onClick={handleInvite}
                        disabled={isLoading}
                        className={`px-6 py-2.5 rounded-xl font-semibold text-white transition-all duration-200 flex items-center gap-2 ${
                            isLoading 
                                ? 'bg-gray-400 cursor-not-allowed' 
                                : 'bg-[#069125] hover:bg-[#057a1f] hover:shadow-lg hover:shadow-[#069125]/30'
                        }`}
                    >
                        {isLoading ? (
                            <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                Sending...
                            </>
                        ) : (
                            <>
                                <span>📧</span>
                                Invite
                            </>
                        )}
                    </button>
                </div>
            </div>

            {/* Messages */}
            {responseMessage && (
                <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-xl text-green-700 text-sm flex items-center gap-2">
                    <span>✅</span>
                    {responseMessage}
                </div>
            )}
            {errorMessage && (
                <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm flex items-center gap-2">
                    <span>⚠️</span>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default AdminInvite;